const generarRecomendaciones = (
	stats
) => {

	const recomendaciones = [];

	const materias =
		stats.materiasStats || {};

	const materiasArray =
		Object.entries(materias)
			.map(([nombre, data]) => {

				const total =
					data.correctas +
					data.incorrectas +
					data.noEntendidas;

				const precision =
					total > 0
						? Math.round(
							(data.correctas / total) * 100
						)
						: 0;

				return {
					nombre,
					precision,
					total,
					incorrectas:
						data.incorrectas
				};
			});

	// =====================
	// PEOR MATERIA
	// =====================

	const peor =
		[...materiasArray]
			.sort(
				(a, b) =>
					a.precision -
					b.precision
			)[0];

	if (peor) {

		recomendaciones.push({
			tipo: "danger",
			titulo:
				`Debes reforzar ${peor.nombre}`,
			texto:
				`Tu precisión es de ${peor.precision}%`
		});
	}

	// =====================
	// MUCHOS ERRORES
	// =====================

	const critica =
		materiasArray.find(
			(m) =>
				m.incorrectas >= 10
		);

	if (critica) {

		recomendaciones.push({
			tipo: "warning",
			titulo:
				`${critica.nombre} está en riesgo`,
			texto:
				`Has fallado ${critica.incorrectas} preguntas`
		});
	}

	// =====================
	// STREAK
	// =====================

	if (
		stats.mejor_streak >= 15
	) {

		recomendaciones.push({
			tipo: "success",
			titulo:
				"Excelente disciplina",
			texto:
				`Tu mejor racha es x${stats.mejor_streak}`
		});
	}

	// =====================
	// CORRUPCIÓN
	// =====================

	if (
		stats.corrupcion >= 70
	) {

		recomendaciones.push({
			tipo: "danger",
			titulo:
				"Corrupción crítica",
			texto:
				"Debes estabilizar tu rendimiento"
		});
	}

	// =====================
	// POCAS RESPUESTAS
	// =====================

	if (
		stats.preguntas_respondidas <
		30
	) {

		recomendaciones.push({
			tipo: "info",
			titulo:
				"Sigue entrenando",
			texto:
				"Necesitamos más datos para analizarte"
		});
	}

	return recomendaciones;
};

export default generarRecomendaciones;